PopOver = require 'app/scripts/views/lib/pop-over'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/member_large_avatar'
{ track } = require '@trello/analytics'

module.exports = class LargeAvatarView extends View
  getViewTitle: -> @model.get('fullName')

  displayType: 'mod-avdetail'

  events:
    'click .js-profile': 'showProfile'

  render: ->
    data = @model.toJSON()

    @$el.html template(data)

    @

  showProfile: ->
    track("Mini Profile", "Large Avatar - Click Profile")
    return
